import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';
import { AppConfigComponent } from './app.config.component';
import { AppMenuComponent } from './app.menu.component';
import { AppMenuitemComponent } from './app.menuitem.component';
import { AppErrorComponent } from './pages/app.error.component';
import { AppAccessdeniedComponent } from './pages/app.accessdenied.component';
import { AppLoginComponent } from './pages/app.login.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password/reset-password.component';

import { MenuService } from './app.menu.service';
import { ApplicationComponent } from './application/application.component';
import { HomeComponent } from './pages/home/home.component';
import { SharedModule } from './shared/shared.module';
import { initialiseData } from './app.init';
import { LoginService } from './services/login.service';
import { CookieService } from 'ngx-cookie-service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ErrorDialogComponent } from './common/error-dialog/error-dialog.component';

import { providePrimeNG } from 'primeng/config';

import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes'

const MyPreset = definePreset(Aura, {
    semantic: {
        colorScheme: {
            light: {
                //...
            },
            dark: {
                //...
            }
        }
    }
});

@NgModule({
  imports: [
    BrowserModule,
    SharedModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgbModule
  ],
  declarations: [
    AppComponent,
    AppMainComponent,
    AppConfigComponent,
    AppMenuComponent,
    AppMenuitemComponent,
    AppLoginComponent,
    AppErrorComponent,
    AppAccessdeniedComponent,
    ApplicationComponent,
    HomeComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ErrorDialogComponent
  ],
  providers: [
    MenuService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: APP_INITIALIZER,
      useFactory: initialiseData,
      multi: true,
      deps: [LoginService]
    },
    CookieService,
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: '.dark',
          // Use your brand primary color
          primary: { color: '#80b7db', contrastColor: '#000000' },
          cssLayer: true
        }
      }
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
